<template>
  <main>
    <RysBanner2
      :page="page"
      :mobilebanner="true"
    />

    <article class="container">
      <div
        v-for="faq in page.acf.faqs"
        :key="faq.ID"
      >
        <a :id="faq.section_id">
          <h3
            v-text="faq.header"
          />
        </a>
        <RysFaqBlock
          v-for="question in faq.questions"
          :key="question.ID"
          :q="question.question"
          :a="question.answer"
        />
      </div>
    </article>
  </main>
</template>

<script>
import yoastToVueMeta from '@/utils/yoast-to-vue-meta';

export default {
  name: 'RysFaq',

  async setup() {
    const wpJson = useWp();

    const { data: page, error: pageError } = await useAsyncData(
      'page-faq',
      () => wpJson.pages.getBySlug('faq')
    );

    if (pageError.value) {
      throw createError({ status: 500, cause: pageError.value });
    }

    if (!page.value) {
      throw createError({ statusCode: 404 });
    }

    return { page };
  },

  head() {
    return yoastToVueMeta(this.page);
  }
};
</script>

<style lang="scss" scoped>
.banner-section {
  background: $thd-black;

  @media screen and (min-width: $breakpoint-lg) {
    padding-top: 40px;
  }

  @media screen and (min-width: $breakpoint-sm) {
    padding-bottom: 24px;
  }

  p.top-text {
    color: $thd-tan;
    font-size: 14px;
    line-height: 18px;
  }

  h1.banner-text::v-deep {
    color: $thd-white;
    font-size: 72px;
    line-height: 64px;
    font-weight: 700;
    margin-top: 0;
    text-transform: uppercase;
    font-stretch: condensed;

    @media screen and (min-width: $breakpoint-lg) {
      font-size: 96px;
      line-height: 96px;
    }

    strong {
      color: $thd-orange;
    }
  }

  .sub-text {
    color: $thd-white;
    font-size: 18px;
    line-height: 24px;
  }

  hr {
    width: 60px;
    color: $thd-tan;
    margin: 40px 0 20px;
  }

  .btn {
    margin: 40px 16px 28px;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    @media screen and (min-width: $breakpoint-lg) {
      margin: 80px 16px 46px;
    }
  }
}
</style>
